import React, { useState, useEffect } from "react";
import { useTheme } from '@repo/shared';
import { useParams, useHistory } from "react-router-dom";
import moment from 'moment';
// Import
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import AttendanceDataService from "../../services/class/AttendanceService";
import ClassDataService from "../../services/class/ClassService";
import StudentDataService from "../../services/student/StudentService";
import LessonDataService from "../../services/class/LessonService";

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import "react-datepicker/dist/react-datepicker.css";

const Attendance = () => {
  const { id } = useParams();
  const history = useHistory();
  const initialAttendanceState = AttendanceDataService.initialiseNewAttendance();
  const [_currentAttendances, setCurrentAttendances] = useState(initialAttendanceState);
  const [students, setStudents] = useState([]);
  const [currentClass, setCurrentClass] = useState({});
  const [attendanceGrid, setAttendanceGrid] = useState([]);
  const [dateHeaders, setDateHeaders] = useState([]);
  const [savingNotes, setSavingNotes] = useState(false);
  const [loading, setLoading] = useState(true);

  const { appTheme } = useTheme();

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const clazz = await ClassDataService.get(id);
      setCurrentClass(clazz);

      const lessons = await LessonDataService.getLessonsForClass(id);

      const incomingDateHeaders = lessons
        .sort((a,b) => moment(a.classDate).diff(moment(b.classDate)))
        .map((l, i) => {
          return { title: moment(l.classDate).format('MMM DD'), editable: true, lesson: l }
        });
      setDateHeaders(incomingDateHeaders);

      const attendances = await AttendanceDataService.getForClass(clazz.id);
      console.log(attendances);
      setCurrentAttendances(attendances);

      const studentsForClass = await StudentDataService.getAllForClass(clazz.id);
      const attendanceGrid = generateAttendanceGrid({attendances, dates: clazz.dates, studentsForClass});

      setAttendanceGrid(attendanceGrid);
      setStudents(studentsForClass);
    } catch (error) {
      console.error('Error fetching attendance data:', error);
    } finally {
      setLoading(false);
    }
  };

  const generateAttendanceGrid = ({attendances, dates, studentsForClass}) => {
    //might not need this

    //columns headers = dates
    //row headers = students
    //cells = attendences[date][student] || empty
    const grid = {};
    studentsForClass.forEach(student => {
      const studentRow = {};
      grid[student.id] = studentRow;
      dates.forEach(date => {
        studentRow[date.getTime()] = {};

        //Here we need to lookup in attendances to see if we have an entry
        const found = attendances.find(attendance => attendance.studentId === student.id && attendance.classDate.getTime() === date.getTime());
        studentRow[date.getTime()].attendance = found ? found.attendance : null;
      });
    });

    return grid;
  };

  const saveNotes = async () => {
    setSavingNotes(true);
    try {
      const _savedNotes = await ClassDataService.saveNotes(currentClass.id, currentClass.notes);
      alert('Notes saved');
      setSavingNotes(false);
    } catch (error) {
      console.error('Error saving notes:', error);
      setSavingNotes(false);
    }
  }

  const renderStudentAttendance = (student, index) => {
    return (
      <tr>
        { false && <td className="attendanceIndexColumn">
          <span className='minorText'>{index}</span>
        </td>}
        <td className="attendanceNameColumn">
          <div>
            <div>
              <span className='majorText'>{student.firstName} {student.lastName}</span>
            </div>
            <div>
              <span className='minorText'>{student.year} {student.className}</span>
            </div>
            <div>
              <span className='minorText'>{student.notes}</span>
            </div>
          </div>
        </td>
        {dateHeaders.map(dateHeader => {
          const attendanceDate = new Date(dateHeader.lesson.classDate);
          const studentRow = attendanceGrid[student.id];
          const cell = studentRow[attendanceDate.getTime()];

          return <td className={'attendanceCheckBox'}>{cell?.attendance ? cell?.attendance : ''}</td>
          
        })}
      </tr>
    )
  };

  const renderBody = () => {
    return (
      <>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
          <div style={{ textAlign: 'center' }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p style={{ marginTop: '10px' }}>Loading Attendance data...</p>
          </div>
        </div>
      ) : (
      <>
      <div className="row">
        <div className="col-sm">
          <h3 className="mb-0">{currentClass.title} { students?.length ? `(${students.length} Students)` : ''}</h3>
          {currentClass.location}
        </div>
        <div className="col-sm">
        </div>
        <div className="col-sm">
          <h2>{currentClass.teacher}</h2>
        </div>
      </div>
      <div style={{margin: 10, width: '80%'}}>
        <div className="form-group">
          <label htmlFor="notes">Notes</label>
          <textarea
            style={{height: 100}}
            type="text"
            className="form-control"
            id="notes"
            name="notes"
            value={currentClass.notes || ''}
            onChange={event => setCurrentClass({ ...currentClass, notes: event.target.value })}
          />
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveNotes}
            disabled={savingNotes}
          >
            {savingNotes ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Saving...
              </>
            ) : (
              "Save Notes"
            )}
          </button>
        </div>
      </div>
      <div className="scrollable">
      <table
          className="table table-striped table-bordered">
        <thead>
        <tr>
            <td>Week Number</td>
            {
              dateHeaders.map((h, index) => {
                const onHeaderClick = () => {
                  //toggleEditRegister(h);
                  history.push(`/lesson/class/${h.lesson.id}`);
                };
                return (
                  <td className={"attendanceHeaderEditingOff"} onClick={onHeaderClick}>
                    <div style={{textAlign: 'center', fontSize: 14}}>{h.lesson.theme ? h.lesson.theme : '\n'}</div>
                    <div style={{textAlign: 'center', fontSize: 14}}>{index+1}</div>
                  </td>)
              })
            }
          </tr>
          <tr>
            <td></td>
            {
              dateHeaders.map((h, index) => {
                const onHeaderClick = () => {
                  //toggleEditRegister(h);
                  history.push(`/lesson/class/${h.lesson.id}`);
                };
                return (
                  <td className={"attendanceHeaderEditingOff"} onClick={onHeaderClick}>
                    <div style={{textAlign: 'center', }}>{h.title}</div>
                  </td>)
              })
            }
          </tr>
        </thead>
        {/* Apply the table body props */}
        <tbody>
          { attendanceGrid && students.map((student,index) => renderStudentAttendance(student, index))}
        </tbody>
      </table>
      </div>
      </>)}
      </>
    )
  }
  return (
    <Container className="py-2 py-lg-4">
      <Row className="justify-content-center">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Header className="d-flex align-items-center gap-2">
              <h2 className="mb-0">Class Register</h2>
            </Card.Header>
            <Card.Body className="p-3" style={{ overflowX: 'auto' }}>
              { renderBody()}
            </Card.Body>
            <Card.Footer className="text-muted">
              
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
  
};

export default Attendance;